import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import Datagrid from "../Components/Datagrid";
import { useNavigate } from "react-router-dom";
import toolbar from "../Config/toolbarConfig";
import { useTranslation } from "react-i18next";

const UserTransactionsPage = () => {
  const [status, setStatus] = useState(null);
  const [url, setUrl] = useState("");

  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const navigate = useNavigate();

  useTitle(`${t("User Transactions")} | Netileti`);

  const getData = async () => {
    setUrl(`${baseUrl}/credits/GetUsers`);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "userId",
      headerText: "Id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "userName",
      headerText: t("User Name"),
      allowEditing: false,
    },
    {
      field: "creditAmount",
      headerText: t("Credit"),
      allowEditing: false,
    },
    {
      field: "",
      headerText: "",
      allowEditing: false,
      textAlign: "center",
      width: "15%",
      template: ({ userId }) => (
        <button
          onClick={() => navigate(`/usertransactions/${userId}`)}
          className="e-btn e-primary e-outline e-small"
        >
          {t("Details")}
        </button>
      ),
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{ url, toolbar: toolbar("EXPORT"), setStatus }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default UserTransactionsPage;
